const isWebApp = () => Boolean(window?.Telegram?.WebApp.initData);

export default isWebApp;
